
import MyVehicleFilterState from "@dana/Store/Data/MyVehicle/MyVehicleFilterState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { AttributeTypeFacetModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";
import { combineReducers } from "redux";

const initialCounterState: MyVehicleFilterState = {
    attributeTypeFacets: null,
     attributeTypeFacet: null,
    defaultAttributeTypeFacets: null,
    clearSearch: false,
    isFilterLoading: false
};

const myVehicleStateImmerReducer = createTypedReducerWithImmer(initialCounterState, {
    "MyVehicle/Filter/IsLoading": (draft: Draft<MyVehicleFilterState>, action: { isLoading: boolean }) => {
        draft.isFilterLoading = action.isLoading;
    },
    "MyVehicle/Filter/PopulateInitialFacet": (draft: Draft<MyVehicleFilterState>, action: { attributeTypeFacets: AttributeTypeFacetModel[] | null }) => {
        draft.defaultAttributeTypeFacets = action.attributeTypeFacets || null;
    },
    "MyVehicle/Filter/ResultFacet": (draft: Draft<MyVehicleFilterState>, action: { attributeTypeFacets: AttributeTypeFacetModel[] | null, attributeTypeFacet: AttributeTypeFacetModel | null}) => {
       
        draft.attributeTypeFacets = action.attributeTypeFacets;
         draft.attributeTypeFacet = action.attributeTypeFacet;
    },

    "MyVehicle/Filter/ClearSearch": (draft: Draft<MyVehicleFilterState>, action: { clearSearch: boolean }) => {
        draft.clearSearch = action.clearSearch;
    },
});

(reducers as any).myVehicleFilter = myVehicleStateImmerReducer;

type MyVehicleReducers = {
    myVehicleFilter: typeof myVehicleStateImmerReducer;
};

export type MyVehicleActions = Parameters<MyVehicleReducers[keyof MyVehicleReducers]>[1] | AnyAction;


